import {useState} from "react";

const DropDown = (
    {
        list = [],
        selected = '',
        key = '',
        placeholder = 'Select',
        onItemSelect = (val) => {},
        classes = ''
    }
) => {

    const [value, setValue] = useState(selected);
    const handleItemSelect = (item) => {
        setValue(item);
        onItemSelect(item);
    }


    return (
        <div className={`drop-down ${classes}`}>
            <div className="drop-down-header">
                {!value &&
                    <div className={`drop-down-title ${value ? '' : 'placeholder'}`}>
                        {placeholder}
                    </div>
                }
                {value &&
                    <div className="">
                        {!key && <div className="drop-down-title">{value}</div>}
                        {key && <div className="drop-down-title">{value[key]}</div>}
                    </div>
                }
            </div>
            <div className="drop-down-content">
                <ul className="drop-down-list">
                    {
                        list.map((item) =>
                            <li key={item} onClick={event => handleItemSelect(item)}>
                                {!key && <div className="content">{item}</div>}
                                {key && <div className="content">{item[key]}</div>}
                            </li>
                        )
                    }
                </ul>
            </div>
        </div>

    )
}

export default DropDown;
